import { fetchAPI } from '@utils/http/apiRequest'

const path = '/restapi/v1/delete/customer/user-cookie'

export const deleteCustomerUserCookie = async ({ cookieHeader }: { cookieHeader?: string }) => {
	return fetchAPI({
		path,
		cookieHeader,
		method: 'POST',
	})
}
